// src/components/InboundAllTimeChart.tsx
import React, { useMemo, useState } from 'react';
import { Card, Empty } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { TimeRangeLinks } from '../ui/TimeRangeLinks';


type Point = { date: string; count: number; cumulative: number };

type Period = 'day' | 'week' | 'month' | 'year';

const D = 24 * 60 * 60 * 1000;

// Парсим YYYY-MM-DD как ЛОКАЛЬНУЮ полночь
const msFromDateKey = (s: string) => {
  const [y, m, d] = s.split('-').map((n) => parseInt(n, 10));
  return new Date(y, (m || 1) - 1, d || 1).getTime();
};
const InboundAllTimeChart: React.FC<{ data: Point[]; height?: number }> = ({ data, height = 420 }) => {
  const [period, setPeriod] = useState<Period>('month');

const filtered = useMemo(() => {
  if (!data || data.length === 0) return [] as Point[];
  const maxT = Math.max(...data.map((p) => msFromDateKey(p.date)));
  const from = maxT - (period === 'day' ? 1 * D : period === 'week' ? 7 * D : period === 'month' ? 30 * D : 365 * D);
  return data.filter((p) => msFromDateKey(p.date) >= from);
}, [data, period]);

  return (
    <Card
      variant="borderless"
      className="stat-card stat-card--accent-blue"
      styles={{ header: { paddingTop: 10, paddingBottom: 8, alignItems: 'center' } }}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span className="stat-card__icon"><InboxOutlined /></span>
          <span className="stat-card__title">Поступления за всё время</span>
        </div>
      }
      // ⬇️ Заменили кнопку "Детализация" на ссылки-фильтры
      extra={<TimeRangeLinks value={period} onChange={setPeriod} />}
    >
      <div style={{ width: '100%', height }}>
        {(!filtered || filtered.length === 0) ? (
          <Empty description="Нет данных" />
        ) : (
          <ResponsiveContainer>
            <LineChart data={filtered}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" minTickGap={24} />
              <YAxis allowDecimals={false} />
              <Tooltip
                labelFormatter={(l) => `Дата: ${l}`}
                formatter={(val: any, key: any) => [String(val) + ' шт', key === 'cumulative' ? 'Накоплено' : 'За день']}
              />
              <Line type="monotone" dataKey="cumulative" dot activeDot={{ r: 5 }} />
            </LineChart>
          </ResponsiveContainer>
        )}
      </div>
    </Card>
  );
};

export default InboundAllTimeChart;
